<template>
  <CoreSelectionDrawer
    has-search
    no-loading-search
    no-filter
    title="Город"
    placeholder="Найти"
    :value="value"
    :items="cities"
    :selected-item="selectedCity"
    :loading="loading"
    :error="error"
    @input="$emit('input', false)"
    @back="$emit('input', false)"
    @click-item="handleClickCity"
    @search:change="handleSearchChange"
  />
</template>

<script setup lang="ts">
import { debounce } from 'lodash'
import { ref, toRefs, watch } from 'vue'
import apiCities from 'src/layouts/core-layout/components/CoreSearch/api/apiCities'
import CoreSelectionDrawer from 'src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue'
import type { ApiCitiesResponseGet } from 'src/layouts/core-layout/components/CoreSearch/api/apiCities.types'

const emit = defineEmits(['input', 'city:selected'])

const props = defineProps<{
  value: boolean
  selectedCity: ApiCitiesResponseGet[number]
}>()
const { value: isVisibleModal } = toRefs(props)

const loading = ref(false)
const error = ref(false)
const searchQuery = ref('')

const cities = ref<ApiCitiesResponseGet>([])
const citiesCache: Map<string, ApiCitiesResponseGet> = new Map()

const loadCities = async () => {
  error.value = false
  loading.value = true

  try {
    const requestData = {
      search: searchQuery.value || undefined,
    }
    const cacheKey = JSON.stringify(requestData)

    if (!citiesCache.has(cacheKey)) {
      const { data } = await apiCities.get(requestData)

      citiesCache.set(cacheKey, data)
    }

    cities.value = citiesCache.get(cacheKey) || []
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
}

const loadCitiesDebounced = debounce(loadCities, 250)

watch(isVisibleModal, async () => {
  if (isVisibleModal.value) {
    await loadCities()
  }
})

const handleClickCity = (city: ApiCitiesResponseGet[number]) => {
  emit('city:selected', city)
}

const handleSearchChange = (query: string) => {
  searchQuery.value = query.trim()

  if (!searchQuery.value || searchQuery.value.length >= 2) {
    loadCitiesDebounced()
  }
}
</script>
